export const generatedCandidateCompositionEvidenceDocket = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-30T00:00:00.000Z",
  "mode": "deterministic-candidate-composition-evidence-docket",
  "operatingRule": "This docket is an evidence acquisition worklist for candidate-specific taxonomy, spectra, mission, sample, archive, or no-evidence-found receipts. It cannot promote resource composition, feedstock, customer-use, scenario, or investment claims by itself.",
  "asteroidCandidateEvidenceLedgerHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
  "candidateSourcePromotionLedgerHash": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
  "candidateSourceClosurePacketHash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
  "candidateSourceReviewDocketHash": "sha256-a3b7bbb0c2d6ec7f65631fdb06e8adeee86a700278b198f83673171bf8196977",
  "acquisitionItemCount": 10,
  "sourceCustodyReadyCount": 0,
  "compositionReadyCount": 0,
  "customerReadyCount": 0,
  "archiveTargetCount": 30,
  "noEvidenceReceiptRequiredCount": 10,
  "laneCounts": {
    "source-custody-before-composition-review": 10
  },
  "resourcePromotionAllowed": false,
  "customerUseAllowed": false,
  "docketState": "blocked-composition-evidence-acquisition",
  "acquisitionItems": [
    {
      "id": "candidate-composition-acquisition-2026-jm2",
      "workOrderId": "small-body-source-work-order-2026-jm2",
      "sourceCandidateId": "cad-2026 JM2",
      "designation": "2026 JM2",
      "queueRank": 1,
      "reviewPriorityScore": 52.39,
      "intakeState": "draft-intake-present-fail-closed",
      "compositionLane": "source-custody-before-composition-review",
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "compositionEvidenceState": "blocked-no-candidate-composition-evidence",
      "resourceClosureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43",
      "sourceUseClosureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18",
      "archiveTargets": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "baseUrl": "https://pds.nasa.gov/datasearch/data-search/",
          "plannedSearchTerms": [
            "2026 JM2",
            "2026 JM2 asteroid taxonomy",
            "2026 JM2 spectra",
            "2026 JM2 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 JM2",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-jm2-pds-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-jm2-pds-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-1e1756bb2fdbe5102e520fb14f7ad49f79cc12439d34bed416f37882d6b74060"
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "baseUrl": "https://archives.esac.esa.int/psa/",
          "plannedSearchTerms": [
            "2026 JM2",
            "2026 JM2 asteroid taxonomy",
            "2026 JM2 spectra",
            "2026 JM2 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 JM2",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-jm2-esa-psa-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-jm2-esa-psa-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-ad8007ea4f9e75df9d19c6f299acabb9f990a73b3317055b386561aed897e709"
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "baseUrl": "https://darts.isas.jaxa.jp/",
          "plannedSearchTerms": [
            "2026 JM2",
            "2026 JM2 asteroid taxonomy",
            "2026 JM2 spectra",
            "2026 JM2 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 JM2",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-jm2-jaxa-darts-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-jm2-jaxa-darts-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-e6c817b1a620da748de8952cca432fcc70c844c59e867a15feea71445cdc22c1"
        }
      ],
      "evidencePacketContract": {
        "payloadKind": "small-body-candidate-composition-evidence",
        "requiredFields": [
          "candidate designation and reviewed alias bridge",
          "source id, source URL, query string, and retrieval timestamp",
          "taxonomy class, spectra product id, mission product id, sample record, or no-evidence-found basis",
          "instrument or observation method and directness rating",
          "units, uncertainty, and applicability limits",
          "raw payload hash and normalized payload hash",
          "license/use note, citation, and reviewer approval"
        ],
        "acceptedEvidenceTypeIds": [
          "taxonomy-spectra-record",
          "mission-or-archive-product",
          "candidate-composition-no-evidence-found-receipt"
        ],
        "rejectedEvidence": [
          "orbit class alone",
          "close-approach geometry alone",
          "generic asteroid-type analog without candidate or alias custody",
          "forum, social, or market commentary without primary source trace"
        ],
        "validatorBoundary": "Attach the reviewed evidence packet to the candidate source intake artifact; resource promotion remains false until the existing work-order intake and promotion gates pass.",
        "contractHash": "sha256-8e7adcbd8ddd2297fff7b8115c409de2f46e41ee78a7f3163f926f24b0c7af80"
      },
      "nextAction": "Close source-custody intake gates, then attach composition evidence or no-evidence-found receipt.",
      "commandSequence": [
        "npm run science:smallbody:composition-intake -- --out evidence/source-candidate-composition/2026-jm2-composition-evidence-intake-report.json evidence/source-candidate-composition/2026-jm2-pds-composition-evidence.json",
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jm2-source-intake-report.json evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:smallbody:composition-docket",
        "npm run science:report"
      ],
      "promotionBoundary": "This acquisition item can organize composition evidence only. It cannot promote resource, feedstock, customer-use, scenario, or investment conclusions until source custody, composition evidence, source-use clearance, and reviewer gates pass.",
      "noEvidenceClosureRule": "If all declared archive targets produce no candidate-specific evidence, close with explicit no-evidence-found receipts and keep resource promotion blocked.",
      "acquisitionItemHash": "sha256-a1eebdc7c5f5082c844d968344a2135a217668f73d723c73c1e0de76dac5774e"
    },
    {
      "id": "candidate-composition-acquisition-2026-em",
      "workOrderId": "small-body-source-work-order-2026-em",
      "sourceCandidateId": "cad-2026 EM",
      "designation": "2026 EM",
      "queueRank": 2,
      "reviewPriorityScore": 44.28,
      "intakeState": "draft-intake-present-fail-closed",
      "compositionLane": "source-custody-before-composition-review",
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "compositionEvidenceState": "blocked-no-candidate-composition-evidence",
      "resourceClosureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43",
      "sourceUseClosureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18",
      "archiveTargets": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "baseUrl": "https://pds.nasa.gov/datasearch/data-search/",
          "plannedSearchTerms": [
            "2026 EM",
            "2026 EM asteroid taxonomy",
            "2026 EM spectra",
            "2026 EM mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 EM",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-em-pds-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-em-pds-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-9ec2078ecf46b081eddb3e267fae8f9459fd7940b16162ffdde8db5a675d6292"
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "baseUrl": "https://archives.esac.esa.int/psa/",
          "plannedSearchTerms": [
            "2026 EM",
            "2026 EM asteroid taxonomy",
            "2026 EM spectra",
            "2026 EM mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 EM",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-em-esa-psa-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-em-esa-psa-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-0ace53a9642df1a1d4e802e2e55bde89f702ddb80a0785cc0c8abc35333ab574"
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "baseUrl": "https://darts.isas.jaxa.jp/",
          "plannedSearchTerms": [
            "2026 EM",
            "2026 EM asteroid taxonomy",
            "2026 EM spectra",
            "2026 EM mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 EM",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-em-jaxa-darts-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-em-jaxa-darts-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-ceef9e1b7771cd711b188a9bb8facb06a3b4c46342a389a1e33cc5b82e2e95b4"
        }
      ],
      "evidencePacketContract": {
        "payloadKind": "small-body-candidate-composition-evidence",
        "requiredFields": [
          "candidate designation and reviewed alias bridge",
          "source id, source URL, query string, and retrieval timestamp",
          "taxonomy class, spectra product id, mission product id, sample record, or no-evidence-found basis",
          "instrument or observation method and directness rating",
          "units, uncertainty, and applicability limits",
          "raw payload hash and normalized payload hash",
          "license/use note, citation, and reviewer approval"
        ],
        "acceptedEvidenceTypeIds": [
          "taxonomy-spectra-record",
          "mission-or-archive-product",
          "candidate-composition-no-evidence-found-receipt"
        ],
        "rejectedEvidence": [
          "orbit class alone",
          "close-approach geometry alone",
          "generic asteroid-type analog without candidate or alias custody",
          "forum, social, or market commentary without primary source trace"
        ],
        "validatorBoundary": "Attach the reviewed evidence packet to the candidate source intake artifact; resource promotion remains false until the existing work-order intake and promotion gates pass.",
        "contractHash": "sha256-6afbd07c0f6a32c9152340e9cf58bb57ff215c3b6e8f968d694b825e536f372d"
      },
      "nextAction": "Close source-custody intake gates, then attach composition evidence or no-evidence-found receipt.",
      "commandSequence": [
        "npm run science:smallbody:composition-intake -- --out evidence/source-candidate-composition/2026-em-composition-evidence-intake-report.json evidence/source-candidate-composition/2026-em-pds-composition-evidence.json",
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-em-source-intake-report.json evidence/source-candidate-payloads/2026-em-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:smallbody:composition-docket",
        "npm run science:report"
      ],
      "promotionBoundary": "This acquisition item can organize composition evidence only. It cannot promote resource, feedstock, customer-use, scenario, or investment conclusions until source custody, composition evidence, source-use clearance, and reviewer gates pass.",
      "noEvidenceClosureRule": "If all declared archive targets produce no candidate-specific evidence, close with explicit no-evidence-found receipts and keep resource promotion blocked.",
      "acquisitionItemHash": "sha256-b111ded2ee731659c9f8c797705b47febf47d1d7439ad48bdd4523a1744c1fce"
    },
    {
      "id": "candidate-composition-acquisition-2026-dn5",
      "workOrderId": "small-body-source-work-order-2026-dn5",
      "sourceCandidateId": "cad-2026 DN5",
      "designation": "2026 DN5",
      "queueRank": 3,
      "reviewPriorityScore": 39.5,
      "intakeState": "draft-intake-present-fail-closed",
      "compositionLane": "source-custody-before-composition-review",
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "compositionEvidenceState": "blocked-no-candidate-composition-evidence",
      "resourceClosureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43",
      "sourceUseClosureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18",
      "archiveTargets": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "baseUrl": "https://pds.nasa.gov/datasearch/data-search/",
          "plannedSearchTerms": [
            "2026 DN5",
            "2026 DN5 asteroid taxonomy",
            "2026 DN5 spectra",
            "2026 DN5 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 DN5",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-dn5-pds-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-dn5-pds-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-f6de432c3a1bf040d2278e20393452c61afa6b9cbaea9d4152b9a241e9171b56"
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "baseUrl": "https://archives.esac.esa.int/psa/",
          "plannedSearchTerms": [
            "2026 DN5",
            "2026 DN5 asteroid taxonomy",
            "2026 DN5 spectra",
            "2026 DN5 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 DN5",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-dn5-esa-psa-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-dn5-esa-psa-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-545b6dc2bdb57ed8152d6b6d9bf89375cabc92f0772679d8d307da731a91254a"
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "baseUrl": "https://darts.isas.jaxa.jp/",
          "plannedSearchTerms": [
            "2026 DN5",
            "2026 DN5 asteroid taxonomy",
            "2026 DN5 spectra",
            "2026 DN5 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 DN5",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-dn5-jaxa-darts-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-dn5-jaxa-darts-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-e34a26869d2c3286fa641c1f7913ba32d23dda2027d4e85325206d616e01135a"
        }
      ],
      "evidencePacketContract": {
        "payloadKind": "small-body-candidate-composition-evidence",
        "requiredFields": [
          "candidate designation and reviewed alias bridge",
          "source id, source URL, query string, and retrieval timestamp",
          "taxonomy class, spectra product id, mission product id, sample record, or no-evidence-found basis",
          "instrument or observation method and directness rating",
          "units, uncertainty, and applicability limits",
          "raw payload hash and normalized payload hash",
          "license/use note, citation, and reviewer approval"
        ],
        "acceptedEvidenceTypeIds": [
          "taxonomy-spectra-record",
          "mission-or-archive-product",
          "candidate-composition-no-evidence-found-receipt"
        ],
        "rejectedEvidence": [
          "orbit class alone",
          "close-approach geometry alone",
          "generic asteroid-type analog without candidate or alias custody",
          "forum, social, or market commentary without primary source trace"
        ],
        "validatorBoundary": "Attach the reviewed evidence packet to the candidate source intake artifact; resource promotion remains false until the existing work-order intake and promotion gates pass.",
        "contractHash": "sha256-38c210c1a28d496b780ddf2370761d2ca7b10caed74f9908056db67e207af39d"
      },
      "nextAction": "Close source-custody intake gates, then attach composition evidence or no-evidence-found receipt.",
      "commandSequence": [
        "npm run science:smallbody:composition-intake -- --out evidence/source-candidate-composition/2026-dn5-composition-evidence-intake-report.json evidence/source-candidate-composition/2026-dn5-pds-composition-evidence.json",
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-dn5-source-intake-report.json evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:smallbody:composition-docket",
        "npm run science:report"
      ],
      "promotionBoundary": "This acquisition item can organize composition evidence only. It cannot promote resource, feedstock, customer-use, scenario, or investment conclusions until source custody, composition evidence, source-use clearance, and reviewer gates pass.",
      "noEvidenceClosureRule": "If all declared archive targets produce no candidate-specific evidence, close with explicit no-evidence-found receipts and keep resource promotion blocked.",
      "acquisitionItemHash": "sha256-073c45db8aa32fd2af0daa38f8a7872551b7161d081e1833e8b37fdf0be6c129"
    },
    {
      "id": "candidate-composition-acquisition-2026-lx",
      "workOrderId": "small-body-source-work-order-2026-lx",
      "sourceCandidateId": "cad-2026 LX",
      "designation": "2026 LX",
      "queueRank": 4,
      "reviewPriorityScore": 39.44,
      "intakeState": "draft-intake-present-fail-closed",
      "compositionLane": "source-custody-before-composition-review",
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "compositionEvidenceState": "blocked-no-candidate-composition-evidence",
      "resourceClosureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43",
      "sourceUseClosureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18",
      "archiveTargets": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "baseUrl": "https://pds.nasa.gov/datasearch/data-search/",
          "plannedSearchTerms": [
            "2026 LX",
            "2026 LX asteroid taxonomy",
            "2026 LX spectra",
            "2026 LX mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 LX",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-lx-pds-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-lx-pds-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-a6e82e05d0268f854fffbf1a102f3ba63e381c83273abe9c558db007a22c43dd"
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "baseUrl": "https://archives.esac.esa.int/psa/",
          "plannedSearchTerms": [
            "2026 LX",
            "2026 LX asteroid taxonomy",
            "2026 LX spectra",
            "2026 LX mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 LX",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-lx-esa-psa-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-lx-esa-psa-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-916794176299ab3cb51425f2a42d541ead3ad81f9fd27bd96e95a5d2b0f47917"
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "baseUrl": "https://darts.isas.jaxa.jp/",
          "plannedSearchTerms": [
            "2026 LX",
            "2026 LX asteroid taxonomy",
            "2026 LX spectra",
            "2026 LX mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 LX",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-lx-jaxa-darts-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-lx-jaxa-darts-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-703f9c09f4048cbaaec4a874c2d95b6d2456d14e7db84c7f76873b233daaf698"
        }
      ],
      "evidencePacketContract": {
        "payloadKind": "small-body-candidate-composition-evidence",
        "requiredFields": [
          "candidate designation and reviewed alias bridge",
          "source id, source URL, query string, and retrieval timestamp",
          "taxonomy class, spectra product id, mission product id, sample record, or no-evidence-found basis",
          "instrument or observation method and directness rating",
          "units, uncertainty, and applicability limits",
          "raw payload hash and normalized payload hash",
          "license/use note, citation, and reviewer approval"
        ],
        "acceptedEvidenceTypeIds": [
          "taxonomy-spectra-record",
          "mission-or-archive-product",
          "candidate-composition-no-evidence-found-receipt"
        ],
        "rejectedEvidence": [
          "orbit class alone",
          "close-approach geometry alone",
          "generic asteroid-type analog without candidate or alias custody",
          "forum, social, or market commentary without primary source trace"
        ],
        "validatorBoundary": "Attach the reviewed evidence packet to the candidate source intake artifact; resource promotion remains false until the existing work-order intake and promotion gates pass.",
        "contractHash": "sha256-b3ee6f1c53506d56c9e866b157a5336c20e78c387c4ac81d9c6564e44303147f"
      },
      "nextAction": "Close source-custody intake gates, then attach composition evidence or no-evidence-found receipt.",
      "commandSequence": [
        "npm run science:smallbody:composition-intake -- --out evidence/source-candidate-composition/2026-lx-composition-evidence-intake-report.json evidence/source-candidate-composition/2026-lx-pds-composition-evidence.json",
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-lx-source-intake-report.json evidence/source-candidate-payloads/2026-lx-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:smallbody:composition-docket",
        "npm run science:report"
      ],
      "promotionBoundary": "This acquisition item can organize composition evidence only. It cannot promote resource, feedstock, customer-use, scenario, or investment conclusions until source custody, composition evidence, source-use clearance, and reviewer gates pass.",
      "noEvidenceClosureRule": "If all declared archive targets produce no candidate-specific evidence, close with explicit no-evidence-found receipts and keep resource promotion blocked.",
      "acquisitionItemHash": "sha256-511581f6f956ba8762114e0a65c58761f9089a3dd2fb20c6b7f87439661741c4"
    },
    {
      "id": "candidate-composition-acquisition-2026-ku1",
      "workOrderId": "small-body-source-work-order-2026-ku1",
      "sourceCandidateId": "cad-2026 KU1",
      "designation": "2026 KU1",
      "queueRank": 5,
      "reviewPriorityScore": 36.59,
      "intakeState": "draft-intake-present-fail-closed",
      "compositionLane": "source-custody-before-composition-review",
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "compositionEvidenceState": "blocked-no-candidate-composition-evidence",
      "resourceClosureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43",
      "sourceUseClosureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18",
      "archiveTargets": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "baseUrl": "https://pds.nasa.gov/datasearch/data-search/",
          "plannedSearchTerms": [
            "2026 KU1",
            "2026 KU1 asteroid taxonomy",
            "2026 KU1 spectra",
            "2026 KU1 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 KU1",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-ku1-pds-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-ku1-pds-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-2f1f1691f185c8b586a69dac99c35d5a1ea73b16aa9f807931e96f968a3be132"
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "baseUrl": "https://archives.esac.esa.int/psa/",
          "plannedSearchTerms": [
            "2026 KU1",
            "2026 KU1 asteroid taxonomy",
            "2026 KU1 spectra",
            "2026 KU1 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 KU1",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-ku1-esa-psa-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-ku1-esa-psa-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-fbb4a76f0e58fae2655964ab70695085da86e3cf6a2edb5fb55308167cba7ff3"
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "baseUrl": "https://darts.isas.jaxa.jp/",
          "plannedSearchTerms": [
            "2026 KU1",
            "2026 KU1 asteroid taxonomy",
            "2026 KU1 spectra",
            "2026 KU1 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 KU1",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-ku1-jaxa-darts-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-ku1-jaxa-darts-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-5c7bab151f1fa7a1f63ad925beba3294631eb760297dd872ce300358aed18d5c"
        }
      ],
      "evidencePacketContract": {
        "payloadKind": "small-body-candidate-composition-evidence",
        "requiredFields": [
          "candidate designation and reviewed alias bridge",
          "source id, source URL, query string, and retrieval timestamp",
          "taxonomy class, spectra product id, mission product id, sample record, or no-evidence-found basis",
          "instrument or observation method and directness rating",
          "units, uncertainty, and applicability limits",
          "raw payload hash and normalized payload hash",
          "license/use note, citation, and reviewer approval"
        ],
        "acceptedEvidenceTypeIds": [
          "taxonomy-spectra-record",
          "mission-or-archive-product",
          "candidate-composition-no-evidence-found-receipt"
        ],
        "rejectedEvidence": [
          "orbit class alone",
          "close-approach geometry alone",
          "generic asteroid-type analog without candidate or alias custody",
          "forum, social, or market commentary without primary source trace"
        ],
        "validatorBoundary": "Attach the reviewed evidence packet to the candidate source intake artifact; resource promotion remains false until the existing work-order intake and promotion gates pass.",
        "contractHash": "sha256-3cf9227f8204dc4d45f2fcb4aa484dd525933adaa6c1d64ab4d1471aeb91f1de"
      },
      "nextAction": "Close source-custody intake gates, then attach composition evidence or no-evidence-found receipt.",
      "commandSequence": [
        "npm run science:smallbody:composition-intake -- --out evidence/source-candidate-composition/2026-ku1-composition-evidence-intake-report.json evidence/source-candidate-composition/2026-ku1-pds-composition-evidence.json",
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-ku1-source-intake-report.json evidence/source-candidate-payloads/2026-ku1-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:smallbody:composition-docket",
        "npm run science:report"
      ],
      "promotionBoundary": "This acquisition item can organize composition evidence only. It cannot promote resource, feedstock, customer-use, scenario, or investment conclusions until source custody, composition evidence, source-use clearance, and reviewer gates pass.",
      "noEvidenceClosureRule": "If all declared archive targets produce no candidate-specific evidence, close with explicit no-evidence-found receipts and keep resource promotion blocked.",
      "acquisitionItemHash": "sha256-6de12e335384e4b2fe961e28891f92bb91d1e62dbafe714b8b15726c622ce8c1"
    },
    {
      "id": "candidate-composition-acquisition-2026-fs5",
      "workOrderId": "small-body-source-work-order-2026-fs5",
      "sourceCandidateId": "cad-2026 FS5",
      "designation": "2026 FS5",
      "queueRank": 6,
      "reviewPriorityScore": 30.19,
      "intakeState": "draft-intake-present-fail-closed",
      "compositionLane": "source-custody-before-composition-review",
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "compositionEvidenceState": "blocked-no-candidate-composition-evidence",
      "resourceClosureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43",
      "sourceUseClosureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18",
      "archiveTargets": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "baseUrl": "https://pds.nasa.gov/datasearch/data-search/",
          "plannedSearchTerms": [
            "2026 FS5",
            "2026 FS5 asteroid taxonomy",
            "2026 FS5 spectra",
            "2026 FS5 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 FS5",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-fs5-pds-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-fs5-pds-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-f0faad973c1b340efec00189bb15df3b911c8611d6264af380ca4660effa86db"
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "baseUrl": "https://archives.esac.esa.int/psa/",
          "plannedSearchTerms": [
            "2026 FS5",
            "2026 FS5 asteroid taxonomy",
            "2026 FS5 spectra",
            "2026 FS5 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 FS5",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-fs5-esa-psa-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-fs5-esa-psa-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-6c3a528d783cabf849ef6411393f4fb7033558e743d1b14b933df773d47dcf49"
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "baseUrl": "https://darts.isas.jaxa.jp/",
          "plannedSearchTerms": [
            "2026 FS5",
            "2026 FS5 asteroid taxonomy",
            "2026 FS5 spectra",
            "2026 FS5 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 FS5",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-fs5-jaxa-darts-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-fs5-jaxa-darts-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-efdb80872f5b847ec8064246dab70aaa00cf01f415245c920231ed379a31e652"
        }
      ],
      "evidencePacketContract": {
        "payloadKind": "small-body-candidate-composition-evidence",
        "requiredFields": [
          "candidate designation and reviewed alias bridge",
          "source id, source URL, query string, and retrieval timestamp",
          "taxonomy class, spectra product id, mission product id, sample record, or no-evidence-found basis",
          "instrument or observation method and directness rating",
          "units, uncertainty, and applicability limits",
          "raw payload hash and normalized payload hash",
          "license/use note, citation, and reviewer approval"
        ],
        "acceptedEvidenceTypeIds": [
          "taxonomy-spectra-record",
          "mission-or-archive-product",
          "candidate-composition-no-evidence-found-receipt"
        ],
        "rejectedEvidence": [
          "orbit class alone",
          "close-approach geometry alone",
          "generic asteroid-type analog without candidate or alias custody",
          "forum, social, or market commentary without primary source trace"
        ],
        "validatorBoundary": "Attach the reviewed evidence packet to the candidate source intake artifact; resource promotion remains false until the existing work-order intake and promotion gates pass.",
        "contractHash": "sha256-fb6403ff4900911a67b167cdd05247a7ba01a31fe21ad4b6d27583731830e6ac"
      },
      "nextAction": "Close source-custody intake gates, then attach composition evidence or no-evidence-found receipt.",
      "commandSequence": [
        "npm run science:smallbody:composition-intake -- --out evidence/source-candidate-composition/2026-fs5-composition-evidence-intake-report.json evidence/source-candidate-composition/2026-fs5-pds-composition-evidence.json",
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-fs5-source-intake-report.json evidence/source-candidate-payloads/2026-fs5-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:smallbody:composition-docket",
        "npm run science:report"
      ],
      "promotionBoundary": "This acquisition item can organize composition evidence only. It cannot promote resource, feedstock, customer-use, scenario, or investment conclusions until source custody, composition evidence, source-use clearance, and reviewer gates pass.",
      "noEvidenceClosureRule": "If all declared archive targets produce no candidate-specific evidence, close with explicit no-evidence-found receipts and keep resource promotion blocked.",
      "acquisitionItemHash": "sha256-eecb8374a8786afe6631b17cdd2a129d027621242489898dfffddeed647604d3"
    },
    {
      "id": "candidate-composition-acquisition-2026-et3",
      "workOrderId": "small-body-source-work-order-2026-et3",
      "sourceCandidateId": "cad-2026 ET3",
      "designation": "2026 ET3",
      "queueRank": 7,
      "reviewPriorityScore": 25.97,
      "intakeState": "draft-intake-present-fail-closed",
      "compositionLane": "source-custody-before-composition-review",
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "compositionEvidenceState": "blocked-no-candidate-composition-evidence",
      "resourceClosureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43",
      "sourceUseClosureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18",
      "archiveTargets": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "baseUrl": "https://pds.nasa.gov/datasearch/data-search/",
          "plannedSearchTerms": [
            "2026 ET3",
            "2026 ET3 asteroid taxonomy",
            "2026 ET3 spectra",
            "2026 ET3 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 ET3",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-et3-pds-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-et3-pds-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-73d3ce9474eaddd007470028f8e750ee8ee8f8be78162fcfb6c8b89de786041d"
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "baseUrl": "https://archives.esac.esa.int/psa/",
          "plannedSearchTerms": [
            "2026 ET3",
            "2026 ET3 asteroid taxonomy",
            "2026 ET3 spectra",
            "2026 ET3 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 ET3",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-et3-esa-psa-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-et3-esa-psa-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-e1824e2c05baef644ee3578ec7f460bd3384a43da31d558c292294c09d7e79b2"
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "baseUrl": "https://darts.isas.jaxa.jp/",
          "plannedSearchTerms": [
            "2026 ET3",
            "2026 ET3 asteroid taxonomy",
            "2026 ET3 spectra",
            "2026 ET3 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 ET3",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-et3-jaxa-darts-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-et3-jaxa-darts-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-d474be9b69f0ab65d9435d9aec3f6de3db3eb7fc9cced3448dc96a728ac129ae"
        }
      ],
      "evidencePacketContract": {
        "payloadKind": "small-body-candidate-composition-evidence",
        "requiredFields": [
          "candidate designation and reviewed alias bridge",
          "source id, source URL, query string, and retrieval timestamp",
          "taxonomy class, spectra product id, mission product id, sample record, or no-evidence-found basis",
          "instrument or observation method and directness rating",
          "units, uncertainty, and applicability limits",
          "raw payload hash and normalized payload hash",
          "license/use note, citation, and reviewer approval"
        ],
        "acceptedEvidenceTypeIds": [
          "taxonomy-spectra-record",
          "mission-or-archive-product",
          "candidate-composition-no-evidence-found-receipt"
        ],
        "rejectedEvidence": [
          "orbit class alone",
          "close-approach geometry alone",
          "generic asteroid-type analog without candidate or alias custody",
          "forum, social, or market commentary without primary source trace"
        ],
        "validatorBoundary": "Attach the reviewed evidence packet to the candidate source intake artifact; resource promotion remains false until the existing work-order intake and promotion gates pass.",
        "contractHash": "sha256-eac0cf99a9c7469505baf8d38b58fd81ef5c9fc64b6b9e663d3970aa5d6c1c03"
      },
      "nextAction": "Close source-custody intake gates, then attach composition evidence or no-evidence-found receipt.",
      "commandSequence": [
        "npm run science:smallbody:composition-intake -- --out evidence/source-candidate-composition/2026-et3-composition-evidence-intake-report.json evidence/source-candidate-composition/2026-et3-pds-composition-evidence.json",
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-et3-source-intake-report.json evidence/source-candidate-payloads/2026-et3-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:smallbody:composition-docket",
        "npm run science:report"
      ],
      "promotionBoundary": "This acquisition item can organize composition evidence only. It cannot promote resource, feedstock, customer-use, scenario, or investment conclusions until source custody, composition evidence, source-use clearance, and reviewer gates pass.",
      "noEvidenceClosureRule": "If all declared archive targets produce no candidate-specific evidence, close with explicit no-evidence-found receipts and keep resource promotion blocked.",
      "acquisitionItemHash": "sha256-6e996b406cd0393a43c40f93c40a014234db36cda8b21668fae6656fef6a1372"
    },
    {
      "id": "candidate-composition-acquisition-2026-jn4",
      "workOrderId": "small-body-source-work-order-2026-jn4",
      "sourceCandidateId": "cad-2026 JN4",
      "designation": "2026 JN4",
      "queueRank": 8,
      "reviewPriorityScore": 24.65,
      "intakeState": "draft-intake-present-fail-closed",
      "compositionLane": "source-custody-before-composition-review",
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "compositionEvidenceState": "blocked-no-candidate-composition-evidence",
      "resourceClosureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43",
      "sourceUseClosureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18",
      "archiveTargets": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "baseUrl": "https://pds.nasa.gov/datasearch/data-search/",
          "plannedSearchTerms": [
            "2026 JN4",
            "2026 JN4 asteroid taxonomy",
            "2026 JN4 spectra",
            "2026 JN4 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 JN4",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-jn4-pds-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-jn4-pds-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-4604575d0cb410312923ab9c402ba0dcdc44409c651fa92e071dd55989d5f7f1"
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "baseUrl": "https://archives.esac.esa.int/psa/",
          "plannedSearchTerms": [
            "2026 JN4",
            "2026 JN4 asteroid taxonomy",
            "2026 JN4 spectra",
            "2026 JN4 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 JN4",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-jn4-esa-psa-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-jn4-esa-psa-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-df89d3e05109d9be9bb994dec26159766ed2d77d55cdd9bdf8193cfb78e0da8f"
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "baseUrl": "https://darts.isas.jaxa.jp/",
          "plannedSearchTerms": [
            "2026 JN4",
            "2026 JN4 asteroid taxonomy",
            "2026 JN4 spectra",
            "2026 JN4 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 JN4",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-jn4-jaxa-darts-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-jn4-jaxa-darts-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-a256c9f11c0dfa3a21595faa9bc282c17be45cdbfd8a9b9ebfadc976c0e0a6b2"
        }
      ],
      "evidencePacketContract": {
        "payloadKind": "small-body-candidate-composition-evidence",
        "requiredFields": [
          "candidate designation and reviewed alias bridge",
          "source id, source URL, query string, and retrieval timestamp",
          "taxonomy class, spectra product id, mission product id, sample record, or no-evidence-found basis",
          "instrument or observation method and directness rating",
          "units, uncertainty, and applicability limits",
          "raw payload hash and normalized payload hash",
          "license/use note, citation, and reviewer approval"
        ],
        "acceptedEvidenceTypeIds": [
          "taxonomy-spectra-record",
          "mission-or-archive-product",
          "candidate-composition-no-evidence-found-receipt"
        ],
        "rejectedEvidence": [
          "orbit class alone",
          "close-approach geometry alone",
          "generic asteroid-type analog without candidate or alias custody",
          "forum, social, or market commentary without primary source trace"
        ],
        "validatorBoundary": "Attach the reviewed evidence packet to the candidate source intake artifact; resource promotion remains false until the existing work-order intake and promotion gates pass.",
        "contractHash": "sha256-397f24cb9d5c6d9fc305f9af1d88d21cfd8d79804d2e6b31a6130cc3a22a9299"
      },
      "nextAction": "Close source-custody intake gates, then attach composition evidence or no-evidence-found receipt.",
      "commandSequence": [
        "npm run science:smallbody:composition-intake -- --out evidence/source-candidate-composition/2026-jn4-composition-evidence-intake-report.json evidence/source-candidate-composition/2026-jn4-pds-composition-evidence.json",
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jn4-source-intake-report.json evidence/source-candidate-payloads/2026-jn4-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:smallbody:composition-docket",
        "npm run science:report"
      ],
      "promotionBoundary": "This acquisition item can organize composition evidence only. It cannot promote resource, feedstock, customer-use, scenario, or investment conclusions until source custody, composition evidence, source-use clearance, and reviewer gates pass.",
      "noEvidenceClosureRule": "If all declared archive targets produce no candidate-specific evidence, close with explicit no-evidence-found receipts and keep resource promotion blocked.",
      "acquisitionItemHash": "sha256-3171937ce6f75a8da5f15e0c8dbfc23684cf4bb287acb059cf9d1fdd42179b92"
    },
    {
      "id": "candidate-composition-acquisition-2026-jv3",
      "workOrderId": "small-body-source-work-order-2026-jv3",
      "sourceCandidateId": "cad-2026 JV3",
      "designation": "2026 JV3",
      "queueRank": 9,
      "reviewPriorityScore": 24.51,
      "intakeState": "draft-intake-present-fail-closed",
      "compositionLane": "source-custody-before-composition-review",
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "compositionEvidenceState": "blocked-no-candidate-composition-evidence",
      "resourceClosureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43",
      "sourceUseClosureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18",
      "archiveTargets": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "baseUrl": "https://pds.nasa.gov/datasearch/data-search/",
          "plannedSearchTerms": [
            "2026 JV3",
            "2026 JV3 asteroid taxonomy",
            "2026 JV3 spectra",
            "2026 JV3 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 JV3",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-jv3-pds-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-jv3-pds-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-43dc093be5913fadd83e4709a56cd1d85d0043fa9839eedca6b0a777f94c78f3"
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "baseUrl": "https://archives.esac.esa.int/psa/",
          "plannedSearchTerms": [
            "2026 JV3",
            "2026 JV3 asteroid taxonomy",
            "2026 JV3 spectra",
            "2026 JV3 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 JV3",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-jv3-esa-psa-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-jv3-esa-psa-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-2c9c9a3219f39f78d6f60b475c8182da1cc8c4da4addd753847e38d331f0f541"
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "baseUrl": "https://darts.isas.jaxa.jp/",
          "plannedSearchTerms": [
            "2026 JV3",
            "2026 JV3 asteroid taxonomy",
            "2026 JV3 spectra",
            "2026 JV3 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 JV3",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-jv3-jaxa-darts-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-jv3-jaxa-darts-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-989ec53253da8c6202ec1a7e08f87585aac7a1af1c247dd4f1c103cc3403c8ff"
        }
      ],
      "evidencePacketContract": {
        "payloadKind": "small-body-candidate-composition-evidence",
        "requiredFields": [
          "candidate designation and reviewed alias bridge",
          "source id, source URL, query string, and retrieval timestamp",
          "taxonomy class, spectra product id, mission product id, sample record, or no-evidence-found basis",
          "instrument or observation method and directness rating",
          "units, uncertainty, and applicability limits",
          "raw payload hash and normalized payload hash",
          "license/use note, citation, and reviewer approval"
        ],
        "acceptedEvidenceTypeIds": [
          "taxonomy-spectra-record",
          "mission-or-archive-product",
          "candidate-composition-no-evidence-found-receipt"
        ],
        "rejectedEvidence": [
          "orbit class alone",
          "close-approach geometry alone",
          "generic asteroid-type analog without candidate or alias custody",
          "forum, social, or market commentary without primary source trace"
        ],
        "validatorBoundary": "Attach the reviewed evidence packet to the candidate source intake artifact; resource promotion remains false until the existing work-order intake and promotion gates pass.",
        "contractHash": "sha256-ee0ca569a153cfb35fa32705025287494c9c3844b62e80703b57c2e3423f3f19"
      },
      "nextAction": "Close source-custody intake gates, then attach composition evidence or no-evidence-found receipt.",
      "commandSequence": [
        "npm run science:smallbody:composition-intake -- --out evidence/source-candidate-composition/2026-jv3-composition-evidence-intake-report.json evidence/source-candidate-composition/2026-jv3-pds-composition-evidence.json",
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jv3-source-intake-report.json evidence/source-candidate-payloads/2026-jv3-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:smallbody:composition-docket",
        "npm run science:report"
      ],
      "promotionBoundary": "This acquisition item can organize composition evidence only. It cannot promote resource, feedstock, customer-use, scenario, or investment conclusions until source custody, composition evidence, source-use clearance, and reviewer gates pass.",
      "noEvidenceClosureRule": "If all declared archive targets produce no candidate-specific evidence, close with explicit no-evidence-found receipts and keep resource promotion blocked.",
      "acquisitionItemHash": "sha256-a0c6bfaa9a5573a69aacf58aef8061b22d55657fcad478a2a680a6f7ddb21062"
    },
    {
      "id": "candidate-composition-acquisition-2026-hz4",
      "workOrderId": "small-body-source-work-order-2026-hz4",
      "sourceCandidateId": "cad-2026 HZ4",
      "designation": "2026 HZ4",
      "queueRank": 10,
      "reviewPriorityScore": 24.43,
      "intakeState": "draft-intake-present-fail-closed",
      "compositionLane": "source-custody-before-composition-review",
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "compositionEvidenceState": "blocked-no-candidate-composition-evidence",
      "resourceClosureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43",
      "sourceUseClosureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18",
      "archiveTargets": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "baseUrl": "https://pds.nasa.gov/datasearch/data-search/",
          "plannedSearchTerms": [
            "2026 HZ4",
            "2026 HZ4 asteroid taxonomy",
            "2026 HZ4 spectra",
            "2026 HZ4 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 HZ4",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-hz4-pds-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-hz4-pds-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-b90072ec6c619c043a8bff28b9c1cfcfb90675c024f3433c8f27b12c017e8e01"
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "baseUrl": "https://archives.esac.esa.int/psa/",
          "plannedSearchTerms": [
            "2026 HZ4",
            "2026 HZ4 asteroid taxonomy",
            "2026 HZ4 spectra",
            "2026 HZ4 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 HZ4",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-hz4-esa-psa-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-hz4-esa-psa-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-18fb3e7345328efeb1cb31396b05bf65fee629b5efd00f28c8ccd88b8914c548"
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "baseUrl": "https://darts.isas.jaxa.jp/",
          "plannedSearchTerms": [
            "2026 HZ4",
            "2026 HZ4 asteroid taxonomy",
            "2026 HZ4 spectra",
            "2026 HZ4 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ],
          "designation": "2026 HZ4",
          "evidencePacketPath": "evidence/source-candidate-composition/2026-hz4-jaxa-darts-composition-evidence.json",
          "noEvidenceReceiptPath": "evidence/source-candidate-composition/2026-hz4-jaxa-darts-no-evidence-found.json",
          "acceptanceRule": "A hit must be tied to the exact candidate designation or a reviewed alias bridge; broad asteroid-class analogs cannot promote this candidate.",
          "archiveTargetHash": "sha256-c8d3d5b19903bab8eddb6be883a81664c4df8c855ba66979b92362568356ca08"
        }
      ],
      "evidencePacketContract": {
        "payloadKind": "small-body-candidate-composition-evidence",
        "requiredFields": [
          "candidate designation and reviewed alias bridge",
          "source id, source URL, query string, and retrieval timestamp",
          "taxonomy class, spectra product id, mission product id, sample record, or no-evidence-found basis",
          "instrument or observation method and directness rating",
          "units, uncertainty, and applicability limits",
          "raw payload hash and normalized payload hash",
          "license/use note, citation, and reviewer approval"
        ],
        "acceptedEvidenceTypeIds": [
          "taxonomy-spectra-record",
          "mission-or-archive-product",
          "candidate-composition-no-evidence-found-receipt"
        ],
        "rejectedEvidence": [
          "orbit class alone",
          "close-approach geometry alone",
          "generic asteroid-type analog without candidate or alias custody",
          "forum, social, or market commentary without primary source trace"
        ],
        "validatorBoundary": "Attach the reviewed evidence packet to the candidate source intake artifact; resource promotion remains false until the existing work-order intake and promotion gates pass.",
        "contractHash": "sha256-117be73ce2178f86a7c3935d05109190ef17e86b651b0aa69d9e386076a64cd6"
      },
      "nextAction": "Close source-custody intake gates, then attach composition evidence or no-evidence-found receipt.",
      "commandSequence": [
        "npm run science:smallbody:composition-intake -- --out evidence/source-candidate-composition/2026-hz4-composition-evidence-intake-report.json evidence/source-candidate-composition/2026-hz4-pds-composition-evidence.json",
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-hz4-source-intake-report.json evidence/source-candidate-payloads/2026-hz4-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:smallbody:composition-docket",
        "npm run science:report"
      ],
      "promotionBoundary": "This acquisition item can organize composition evidence only. It cannot promote resource, feedstock, customer-use, scenario, or investment conclusions until source custody, composition evidence, source-use clearance, and reviewer gates pass.",
      "noEvidenceClosureRule": "If all declared archive targets produce no candidate-specific evidence, close with explicit no-evidence-found receipts and keep resource promotion blocked.",
      "acquisitionItemHash": "sha256-0b007b54a2269da9f2864fa73248284ececa4bbe70a6d85745af9d7bfdde3943"
    }
  ],
  "docketHash": "sha256-3182332347d7d462dee4cf1f5d3a09c21299bf4798425db894d2e37640530184"
}
;
